﻿angular.module('app.financeiro').factory('baixaTituloManualFactory', ['$http', '$q', 'errorService', function ($http, $q, errorService) {
    var _apiName = 'RetornoBanco';

    var _listBaixaManual = function (search, options, codigoParamBanco, dataInicio, dataTermino, tipo) {
        var dto = options.data;
        dto.search = search;
        dto.parms = [];
        dto.parms.push({ "name": "CodigoParamBanco", "value": codigoParamBanco });
        dto.parms.push({ "name": "DataInicio", "value": dataInicio });
        dto.parms.push({ "name": "DataTermino", "value": dataTermino });
        dto.parms.push({ "name": "Tipo", "value": tipo });
        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListBaixaManual', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _baixaManual = function (dto) {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/BaixaManual', dto);
    };

    var _findBoletoRecord = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/FindBoletoRecord', dto);
    };

    var _reprocessaNotificacao = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ReprocessaNotificacao', dto);
    }

    var _listNotificacoesBoleto = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListNotificacoesBoleto', dto);
    };

    var factory = {};

    factory.listBaixaManual = _listBaixaManual;
    factory.baixaManual = _baixaManual;
    factory.findBoletoRecord = _findBoletoRecord;
    factory.reprocessaNotificacao = _reprocessaNotificacao;
    factory.listNotificacoesBoleto = _listNotificacoesBoleto;

    return factory;
}]);
